module.exports = __webpack_public_path__ + "static/img/membership_service.fa2ea69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/membership_service.png
// module id = y702
// module chunks = 1